import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-efos',
  templateUrl: './info-efos.component.html',
  styleUrls: ['./info-efos.component.css']
})
export class InfoEfosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/info-efos/info-efos.component.ts